import _AttachmentTray from '../_internal/components/AttachmentTray';
export const AttachmentTray = _AttachmentTray;